import Vue from 'vue';
import store from './store';
import router from './routes/index.js';
import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import VueTelInputVuetify from 'vue-tel-input-vuetify';

Vue.use(VueTelInputVuetify, {
  vuetify,
});

// Component App
import App from './App.vue';
import LayoutRegister from '@/components/Layout/LayoutRegister';

// External Librarys
var VueCookie = require('vue-cookie');
import Toast from 'vue-toastification';

// CSS
import 'bootstrap-4-grid/css/grid.min.css';
import 'vue-toastification/dist/index.css';

// Const
import { optionsToasted } from '@/const';

Vue.component('LayoutRegister', LayoutRegister);

Vue.use(VueCookie);
Vue.use(Toast, optionsToasted);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
  store,
  vuetify,
  i18n,
  created() {
    this.$store.dispatch('register/checkCookies');
  },
}).$mount('#app');
